import React from 'react';

const ProgressBarWidget = ({ title, data, onClick }) => {
  const handleItemClick = (item) => {
    if (onClick) {
      onClick({ type: 'progressItem', title, data: item });
    }
  };

  const handleViewAll = () => {
    if (onClick) {
      onClick({ type: 'progressViewAll', title, data });
    }
  };

  return (
    <div className="h-full bg-white p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <button
          onClick={handleViewAll}
          className="text-secondary-600 hover:text-secondary-800 text-sm font-medium hover:underline"
        >
          View All
        </button>
      </div>
      <div className="flex-1 overflow-y-auto space-y-4">
        {data.map((item, index) => (
          <div
            key={item.id || index}
            onClick={() => handleItemClick(item)}
            className="cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">{item.name}</span>
              <span className="text-sm font-semibold text-gray-900">{item.value}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className="h-2.5 rounded-full transition-all duration-300"
                style={{
                  width: `${Math.min(item.value, 100)}%`,
                  backgroundColor: item.color || '#3B82F6',
                }}
              />
            </div>
            {item.subtitle && (
              <p className="text-xs text-gray-500 mt-1">{item.subtitle}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBarWidget;
